// CustomSnackbar.js
import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";

const CustomSnackbar = ({
    open,
    handleClose,
    message,
    severity = "info",
    duration = 6000,
    description = "",
}) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={duration}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
            <Alert
                onClose={handleClose}
                severity={severity}
                sx={{ width: "100%", display: "flex", alignItems: "center" }}
            >
                {message}
                <Tooltip title={description} arrow>
                    <InfoOutlinedIcon
                        sx={{ marginLeft: 1, cursor: "pointer" }}
                    />
                </Tooltip>
            </Alert>
        </Snackbar>
    );
};

export default CustomSnackbar;
